import { loadJs } from "@/lib/loadJs";

export const initLiveChat = () => {

  const url = "//image.providesupport.com/js/1wdgpaa29jc8b16y815pk3z6jm/safe-textlink.js?ps_h=eT4L&ps_t=1599787579083&online-link-html=%3Cdiv%20id%3D%27scEcsr-online4%27%3E%3C/div%3E&offline-link-html=%3Cdiv%20id%3D%27scEcsr-offline4%27%3E%3C/div%3E";
  loadJs(url).then(() => {

    const lcCPInterval = setInterval(() => {
      const online = document.getElementById('scEcsr-online4');
      const offline = document.getElementById('scEcsr-offline4');


      if (online || offline) {

        const liveChatIcon = document.querySelector('.livechat__icon') as HTMLElement
        const footerCaptionMain = document.querySelector('.footer-captionMain') as HTMLElement
        const livechatHide = document.querySelector('.livechat__hide') as HTMLElement

        // 如果是offline，那就给icon加上office样式，显示zzz
        if (offline) {
          if (liveChatIcon) {
            liveChatIcon.classList.remove('online');
            liveChatIcon.classList.add('offline');
          }
        }

        if (footerCaptionMain) {
          footerCaptionMain.classList.remove('hidden');
        }

        if (liveChatIcon) {
          liveChatIcon.addEventListener('click', () => {
            const previousElement = liveChatIcon.previousElementSibling as HTMLElement;
            if (previousElement) {
              previousElement.style.display = 'block'; // 显示上一个元素
            }
            liveChatIcon.style.display = 'none'; // 隐藏当前点击的元素
          })
        }

        if (livechatHide) {
          livechatHide.addEventListener('click', function () {

            const liveChatBox = livechatHide.closest('.livechat__box') as HTMLElement;
            if (liveChatBox) {
              liveChatBox.style.display = 'none'; // 隐藏 .livechat-box
              const nextElement = liveChatBox.nextElementSibling as HTMLElement;
              if (nextElement) {
                nextElement.style.display = 'block'; // 显示下一个元素
              }
            }

          });
        }
        // 如果加载完成，那就清掉 setInterval
        clearInterval(lcCPInterval);
      }
    }, 200);

  });
}